export default __webpack_public_path__ + "media/images/main/checkbox-f78a8dfb0c748df8cffd8b053c96b25c.png";